import { RND } from "../RND";

export class ArrayUtils {
    //-------------------------------------------------------------------------
    /**
     * Nahodne zamicha pole
     * @param array 
     */
    //-------------------------------------------------------------------------
    static shuffle<T>(array: T[], rnd: RND): T[] {
        let currentIndex = array.length;
        let temporaryValue: any;
        let randomIndex: number;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(rnd.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }
}